import { VueReCaptcha } from 'vue-recaptcha-v3';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueReCaptcha, {
        siteKey: nuxtApp.$config.public.RECAPTCHA_SITE_KEY,
        loaderOptions: {
            autoHideBadge: false,
        },
    });
});